import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1.7rem",
  fill: "currentColor",
  class: "bi bi-arrow-left",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1.7rem",
  fill: "currentColor",
  class: "bi bi-list-ul",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })
], -1)
const _hoisted_5 = { class: "navbar-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1.7rem",
  fill: "currentColor",
  class: "bi bi-0-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z" })
], -1)
const _hoisted_7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1.7rem",
  fill: "currentColor",
  class: "bi bi-0-square",
  viewBox: "0 0 16 16"
}
const _hoisted_8 = {
  y: "115%",
  x: "100%",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  transform: "scale(.5)"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", { d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z" }, null, -1)
const _hoisted_10 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1.7rem",
  fill: "currentColor",
  class: "bi bi-cart3",
  viewBox: "0 0 16 16"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", { d: "M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "75%",
  cy: "25%",
  r: "25%"
}, null, -1)
const _hoisted_13 = {
  x: "75%",
  y: "29%",
  "dominant-baseline": "middle",
  "text-anchor": "middle",
  fill: "white",
  "font-size": "25%"
}
const _hoisted_14 = {
  key: 1,
  class: "offline-warning"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Připojení k síti ztraceno (Offline)", -1)
const _hoisted_16 = [
  _hoisted_15
]

import { computed, ref, watch } from 'vue';
import { RouterView } from 'vue-router';
import { useRoute } from 'vue-router';
import { useCartStore } from '@/store/CartStore';
import { useStaffStore } from '@/store/StaffStore';
import { nextCartPaneState, goToCategorySelect, isCategorySelected, cartPaneState } from '@/services/SubNavigation';
import { useShopHub } from './services/ShopHub';
import { useLocalSettings } from './services/LocalSettings';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const localSettings = useLocalSettings();
localSettings.load();

const route = useRoute();
const isStaffMode = computed(() => route.path.includes('/staff'))

const shopHub = useShopHub();
const hasConnection = ref(shopHub.IsConnected);

shopHub.Established.on(()=>{
    hasConnection.value = true;
});
shopHub.Disconnected.on(()=>{
    hasConnection.value = false;
});
shopHub.connect();


const staffStore = useStaffStore();
watch(isStaffMode, (current, old) => {
    if (current) {
        console.log("staff start");
        staffStore.start();
    } else {
        console.log("staff stop");
        staffStore.stop();
    }
});

const cartStore = useCartStore();
const bodyClass = computed(() => {
    switch (route.path) {
        case '/purchase':
            if (cartStore.newOrderProcessBegun) {
                return 'orange';
            }
            return 'green';
        case '/staff-order': //fallthrough
        case '/staff':
        case '/staff-finished':
            return 'blue';
        default:
            return '';
    }
})
const productAmountsSum = computed(() => cartStore.products.map(p => p.amount).reduce((s, p) => s + p));

const showNavBar = computed(() => route.path != "/display");


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showNavBar))
      ? (_openBlock(), _createElementBlock("nav", {
          key: 0,
          id: "nav",
          class: _normalizeClass('navbar navbar-expand-lg bg-light ' + _unref(bodyClass))
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_unref(cartPaneState) != 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(isCategorySelected))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToCategorySelect)('/purchase')))
                      }, _hoisted_3))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: _unref(isStaffMode) ? '/staff-order' : '/purchase',
                        class: "btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["to"]))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(cartStore).newOrderProcessBegun ? 'Vytváření objednávky' : _unref(route).name), 1),
            _createElementVNode("div", null, [
              (_unref(isStaffMode))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/staff-finished",
                    class: "btn"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isStaffMode))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/staff",
                    class: "btn"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                        _createElementVNode("text", _hoisted_8, _toDisplayString(_unref(staffStore).unfinishedOrdersCount), 1),
                        _hoisted_9
                      ]))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(nextCartPaneState) && _unref(nextCartPaneState)(...args)))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                  _hoisted_11,
                  (_unref(cartStore).products.length && _unref(productAmountsSum))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_12,
                        _createElementVNode("text", _hoisted_13, _toDisplayString(_unref(productAmountsSum)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_unref(RouterView), {
      class: _normalizeClass('side-paddings ' + _unref(bodyClass))
    }, null, 8, ["class"]),
    (!hasConnection.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true)
  ], 64))
}
}

})